import React from 'react'
import { IframeLayout } from '../../components/Layouts';
import { ErrorBoundary } from '@sentry/react';
import { ErrorMsg } from '../../components/AppMessages';
import { IframePageContent } from '../../components/PageContent';
import LoadingEllipsis from '../../components/Loading/LoadingEllipsis';
import { useStreamlitEmbedUrl } from '../../hooks';

const VisitToLeadTool = () => {
  const baseUrl = "https://v2l-trend-app.streamlit.nissan-cedar.com/?embed=true";

  const { iframeUrl, isFetching } = useStreamlitEmbedUrl("visitToLeadToolToken", baseUrl);

  return (
    <IframeLayout hasFilter={false}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {isFetching ?
          <LoadingEllipsis isLoading={isFetching} />
          :
          <IframePageContent
            frameId="visitToLeadTool"
            iframeUrl={iframeUrl} // Use the iframe URL with the token query parameters
          />
        }

      </ErrorBoundary>
    </IframeLayout>
  );
}

export default VisitToLeadTool
